// @flow
import styled from "styled-components"

export const AffiliateOnboardingWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-height: calc(100vh - 8rem);
  margin-top: 1rem;
`
export const StepWrapper = styled.div`
  width: 90vw;
  max-width: 96rem;
  margin: 0 auto;
  padding-top: 5rem;
`

export const StepBack = styled.div`
  padding: 0.5rem;
  border-radius: 0.2rem;
  color: ${(props) => props.theme.color.lightGray};
  font-weight: ${(props) => props.theme.fontWeights.bold};
  cursor: pointer;
  text-decoration: underline;

  &:before {
    content: "<";
  }
`

export const Steps = styled.div`
  padding-top: 1rem;
  padding-bottom: 2rem;
`



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/styled.js